import React from 'react';
import { PromoPackModalContextType } from './types';

const PromoPackModalContext = React.createContext<
  PromoPackModalContextType | undefined
>(undefined);

export default PromoPackModalContext;
